<template>
    <div class="w-full my-6">
        <div class="bg-nomad-950 rounded-lg overflow-hidden hover:shadow-lg transition-all duration-300">
            <!-- Header -->
            <div class="bg-gradient-to-r from-nomad-800 to-nomad-900 px-6 py-6">
                <div class="flex items-center justify-between gap-6">
                    <div>
                        <h2 class="text-xl font-bold text-white">Trending</h2>
                        <p class="text-nomad-300 text-xs mt-1">Currently playing by others</p>
                    </div>
                    <div v-if="current && current.id" class="flex-1 flex items-center gap-3 justify-end">
                        <div class="text-right hidden sm:block">
                            <h3 class="text-nomad-accent font-medium text-sm truncate">{{ current.name }}</h3>
                            <p class="text-nomad-300 text-xs">{{ current.artist?.name }}</p>
                        </div>
                        <button @click="playSong"
                            class="flex-shrink-0 icon-play rounded-full bg-nomad-accent hover:bg-nomad-accent/80 text-nomad-900 w-10 h-10 flex items-center justify-center transition-all hover:scale-110"></button>
                    </div>
                </div>
            </div>

            <!-- Carousel -->
            <div class="px-6 py-6 bg-nomad-900">
                <Carousel ref="trendingCarousel" :settings="settings" :breakpoints="breakpoints" v-if="songs.length">
                    <Slide v-for="song in songs" :key="song.song_id">
                        <button @click="handleSlideStart(song.song)"
                            class="h-24 rounded-lg items-center grid text-nomad-50 hover:text-nomad-accent bg-nomad-800 hover:bg-nomad-700 hover:shadow-md w-full mx-2 px-4 transition-all duration-300 focus:outline-none group">
                            <div class="w-full text-left">
                                <h4
                                    class="font-semibold text-lg group-hover:text-nomad-accent transition-colors  line-clamp-1">
                                    {{ song.song.name }}</h4>
                                <p class="font-light text-md text-nomad-300 mt-1 line-clamp-1">
                                    {{ song.song.artist.name }}
                                </p>
                            </div>
                        </button>
                    </Slide>
                </Carousel>

                <!-- Skeleton Loading State -->
                <Carousel ref="trendingCarousel" :settings="settings" :breakpoints="breakpoints" v-else>
                    <Slide v-for="song in [{ id: 1 }, { id: 2 }, { id: 3 }]" :key="song.id">
                        <button
                            class="h-24 rounded-lg bg-nomad-800/50 w-full mx-2 focus:outline-none animate-pulse"></button>
                    </Slide>
                </Carousel>
            </div>
        </div>
    </div>
</template>
<script setup>
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";
import { ref } from "vue";
import { mapActions, mapGetters, useStore } from "vuex";
import Tile from '@/components/Tile.vue'
const props = defineProps({ songs: { type: Array, default: [] } });
const trendingCarousel = ref(null)
const background = ref('https://nomadlyrics.sfo2.cdn.digitaloceanspaces.com//static/artists/yK1Z158feMMYMRRLO462F7cuM1EiGWSLIRwH3BWG.jpg')

const current = ref()
const store = useStore()

if (props.songs.length > 0)
    current.value = props.songs[0].song

const settings = {
    itemsToShow: 1.2,
    snapAlign: "center",
};

const breakpoints = {
    700: {
        itemsToShow: 2.2,
        snapAlign: "center",
    },
    1024: {
        itemsToShow: 4.2,
        snapAlign: "start",
    },
};

function playSong() {
    store.dispatch('current/prepareCurrent', { id: current.value.id, type: 'SONG' })
}

function handleSlideStart(event) {
    current.value = event
    if (event.cover)
        background.value = event.cover
    else
        background.value = event.artist.image
}
</script>
